import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import MakeRequest from '../Components/Helpers/MakeRequest';
import { useOutletContext, Link, useNavigate } from 'react-router-dom';

const Tests = () => {
    const { l } = useOutletContext();
    const navigate = useNavigate();

    const [tests, setTests] = useState([]);
    const [visibleCount, setVisibleCount] = useState(12); // 4 rows * 3 cards per row on lg
    const [pageContent, setPageContent] = useState({
        ingressSwe: '',
        ingressEng: ''
    });

    useEffect(() => {
        const fetchTests = async () => {
            try {
                const response = await MakeRequest(null, 'content/references', 'get');
                if (response.data) {
                    const filteredData = response.data
                        .filter(ref => "Tests" === ref.type)
                        .sort((a, b) => (a.order || 9999) - (b.order || 9999));
                    setTests(filteredData);
                }
            } catch (error) {
                console.error('Error fetching tests:', error);
            }
        };
        
        const fetchPageContent = async () => {
            try {
                const response = await MakeRequest(null, 'content/pageContent?page=tests', 'get');
                if (response.data && response.data[0]) {
                    setPageContent({
                        ingressSwe: response.data[0].ingressSwe || '',
                        ingressEng: response.data[0].ingressEng || ''
                    });
                }
            } catch (error) {
                console.error('Error fetching page content:', error);
            }
        };
        
        fetchTests();
        fetchPageContent();
    }, []);

    const handleReferenceClick = (reference) => {
        navigate(`/references/${reference._id}`, { state: { reference } });
    };

    const bgColors = ["#f8f9fa", "#e9ecef", "#dee2e6"]; // light gray variations

    const truncate150 = (text) =>
        text?.length > 150 ? text.slice(0, 150) + '...' : text;

    const canShowMore = visibleCount < tests.length;

    return (
        <>
            <Container className="my-lg-5 my-3">
                {/* Header + Back link */}
                <Row className="g-3 align-items-center mb-4">
                    {/* Title */}
                    <Col xs="auto" className="d-flex align-items-center">
                        <h1 className="fw-bold mb-0 me-3">
                            {l('Tester', 'Tests')}
                        </h1>
                    </Col>
                </Row>

                {/* Paragraph - full width on small/medium, half width on lg+ */}
                <Row className="mb-2">
                    <Col xs={12} lg={6}>
                        <p className="text-muted lead mb-0 test-paragraph">
                            {pageContent.ingressSwe || pageContent.ingressEng ? (
                                l(pageContent.ingressSwe, pageContent.ingressEng)
                            ) : (
                                l(
                                    'Vårt längst löpande praktiska fälttest är 25 år. Som färgtillverkare testar vi kontinuerligt våra produkter. Men labbtester fångar sällan verkligheten, därför är det viktigt att ha praktiska tester på faktiska objekt. Nedan kan ni ta del av de tester som utförts. Samt en översikt över syfte och över hur lång tid de löpt. Genomgående har det visats att Isotrol grundfärg uppvisar ypperliga resultat på rostiga ytor.',
                                    'Our longest running practical field test is 25 years. As a paint manufacturer, we continuously test our products. But lab tests rarely capture reality, so it is important to have practical tests on actual objects. Below you can take part of the tests that have been carried out. As well as an overview of the purpose and how long they have run. Throughout, it has been shown that Isotrol primer shows excellent results on rusty surfaces.'
                                )
                            )}
                        </p>
                    </Col>
                </Row>

                {/* Cards */}
                <Row className="g-3 g-md-4 mt-1">
                    {tests?.slice(0, visibleCount).map((test, index) => (
                        <Col
                            key={test._id?.$oid || index}
                            xs={12}
                            sm={6}
                            lg={4}
                            className="d-flex"
                        >
                            <Card
                                className="h-100 shadow-sm w-100 position-relative"
                                style={{
                                    borderRadius: '15px',
                                    backgroundColor: bgColors[index % bgColors.length],
                                }}
                            >
                                <Card.Body className="d-flex flex-column">
                                    <Card.Title className="mb-2">{l(test.titleSwe, test.titleEng)}</Card.Title>

                                    <Card.Text
                                        className="mb-3 flex-grow-1"
                                        style={{ whiteSpace: 'pre-line' }}
                                    >
                                        {l(truncate150(test.contentSwe), truncate150(test.contentEng))}
                                    </Card.Text>

                                    {/* Use an anchor for proper stretched-link behavior */}
                                    <a
                                        href="#"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            handleReferenceClick(test);
                                        }}
                                        className="stretched-link fw-bold"
                                        style={{ color: 'var(--bs-primary)' }}
                                        aria-label={l('Läs mer', 'Read more')}
                                    >
                                        {l('Läs mer →', 'Read more →')}
                                    </a>
                                </Card.Body>
                            </Card>
                        </Col>
                    ))}
                </Row>

                {canShowMore && (
                    <div className="text-center mt-3">
                        <Button variant="primary" onClick={() => setVisibleCount((v) => v + 12)}>
                            {l('Visa mer', 'Show more')}
                        </Button>
                    </div>
                )}
            </Container>

        </>

    );
};

export default Tests;
